export default __webpack_public_path__ + "static/media/hero-phone-2.adff05ca.png";